import React from 'react';
import { Box } from '@mui/material';
import { getStyles } from './styles';
import { LocationSelect } from 'src/components/location-select';

const DashboardHeader: React.FC = () => {
  const styles = getStyles(false);

  return (
    <Box sx={styles.container}>
      <LocationSelect />
    </Box>
  );
};

export { DashboardHeader };
